// Polyfills for iOS 16 / Safari 16 which lack ES2023-2024 builtins.
if (typeof Object.groupBy !== 'function') {
  Object.groupBy = function groupBy(iterable, callbackFn) {
    return Array.from(iterable).reduce((obj, value, index) => {
      const key = callbackFn(value, index);
      if (key in obj) {
        obj[key].push(value);
      } else {
        obj[key] = [value]; // eslint-disable-line no-param-reassign
      }
      return obj;
    }, Object.create(null));
  };
}

if (typeof Array.prototype.toSorted !== 'function') {
  // eslint-disable-next-line no-extend-native
  Array.prototype.toSorted = function toSorted(compareFn) {
    return Array.from(this).sort(compareFn);
  };
}

import('./bootstrap');
